export default "__VITE_ASSET__BLP8WwlY__"